module.exports = __webpack_public_path__ + "img/93.424c0d55.jpg";